import React from 'react'
import { IframePageContent } from '../../components/PageContent';
import { ErrorMsg } from '../../components/AppMessages';
import { IframeLayout } from '../../components/Layouts';
import { ErrorBoundary } from '@sentry/react';
import LoadingEllipsis from '../../components/Loading/LoadingEllipsis';
import { useStreamlitEmbedUrl } from '../../hooks';

const SeriousBuyer = () => {
  const baseUrl = "https://serious-buyer-app.streamlit.nissan-cedar.com/?embed=true";

  const { iframeUrl, isFetching } = useStreamlitEmbedUrl("seriousBuyerToken", baseUrl);

  return (
    <IframeLayout hasFilter={false}>
      <ErrorBoundary fallback={<ErrorMsg />}>
        {isFetching ?
          <LoadingEllipsis isLoading={isFetching} />
          :
          <IframePageContent
            frameId="seriousBuyer"
            iframeUrl={iframeUrl} // Use the iframe URL with the token query parameters
          />
        }

      </ErrorBoundary>
    </IframeLayout>
  );
}

export default SeriousBuyer
